import { useRef, useEffect, useState } from "react";
import { shallowEqual, useSelector, connect, useDispatch } from "react-redux";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as auth from "./authRedux";
import { getUserByToken } from "./authCrud";
import { RootState } from "../../../../redux/rootReducer";
import { injectIntl } from "react-intl";
import { useFlags } from "../../../../config/featureFlags";

function AuthInit(props) {
  const { DISPLAY_LIKUMI_CONTENT, DISPLAY_CODE_CONTENT } = useFlags();
  const didRequest = useRef(false);
  const dispatch = useDispatch();
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const { accessToken } = useSelector(
    ({ auth }: RootState) => ({
      accessToken: auth.accessToken,
    }),
    shallowEqual
  );
  useEffect(() => {
    document.title = props.intl.formatMessage({
      id: `${process.env.REACT_APP_SITE_TYPE}.PAGE.TITLE`,
    });
  }, [props.intl.locale]);

  useEffect(() => {
    if (DISPLAY_LIKUMI_CONTENT) {
      let link = document.querySelector("link[rel*='icon']");
      if (link instanceof HTMLLinkElement) {
        link.href = `${window.location.origin}/media/logos/oslogo-01.svg`;
      }
    }
  });

  // We should request user by accessToken before rendering the application
  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const {
            data: { user },
          } = await getUserByToken();
          dispatch(props.fulfillUser(user));
        }
      } catch (error) {
        console.error(error);
        if (!didRequest.current) {
          dispatch(props.logout());
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    if (accessToken) {
      requestUser();
    } else {
      dispatch(props.fulfillUser(undefined));
      setShowSplashScreen(false);
    }
    // eslint-disable-next-line
  }, []);

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>;
}

export default injectIntl(connect(null, auth.actions)(AuthInit));
